/*******************************************************************************
 
    Project: Multipress
    Author: Lap Development / Dominik Kucharski
    Date: 04.2016
 
********************************************************************************

    1. Scroll to top
    2. Off canvas menu
    3. Mobile Menu
    4. Home Slideshow
    5. Footer
    6. Subpage header
    7. Transitions between pages
 
*******************************************************************************/

jQuery( document ).ready(function($) {

/* 1. Scroll to top
------------------------------------------------------------------------------*/
    
    $(document).on( 'scroll', function(){
        if ($(window).scrollTop() > 200) {
            $('.scroll-to-top').addClass('show');
        } else {
            $('.scroll-to-top').removeClass('show');
        }
    });

    $('.scroll-to-top').on('click', function(event) {
        event.preventDefault();
        var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
        var element = $('body');
        var offset = element.offset();
        var offsetTop = offset.top;
        $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
    });

/* 2. Off canvas menu
------------------------------------------------------------------------------*/

    $('.toggle-nav').click(function(e) {
        // Calling a function in case you want to expand upon this.
        e.preventDefault();
        toggleNav();
    });

    function toggleNav() {
        if ($('#site-wrapper').hasClass('show-nav')) {
            // Do things on Nav Close
            $('#site-wrapper').removeClass('show-nav');
        } else {
            // Do things on Nav Open
            $('#site-wrapper').addClass('show-nav');
        }
    }

    // Fuction for hiding mobile navigation
    function hideNav() {
        if ($('#site-wrapper').hasClass('show-nav')) {
            $('#site-wrapper').removeClass('show-nav');
        }
    }

    // Hide navigation when user pressed Escape key on keyboard
    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            if ($('#site-wrapper').hasClass('show-nav')) {
                toggleNav();
            }
        } 
    });

    // Hide mobile navigation when user increases browser size
    enquire.register("screen and (min-width: 768px)", {
        match : function() {
            hideNav();
        }
    });

/* 3. Mobile Menu
------------------------------------------------------------------------------*/

    $('ul.mob-menu li').has('ul').addClass('parentLi');
    $('ul.mob-menu li ul').addClass('sub-menu');
    $('ul.mob-menu .parentLi').prepend('<a href="#" class="caret"></a>');
    $('.parentLi a').matchHeight();

    $('ul.mob-menu .sub-menu').hide();

    $('ul.mob-menu .caret').on('click', function(event){
        event.preventDefault();
        $(this).parent().find('ul.sub-menu').slideToggle();
    });

    $('.mobile-language li').has('ul').addClass('parentLi').prepend('<a href="#" class="caret"></a>');

    $('.lang-submenu').hide();

    $('.mobile-language .caret').on('click', function(event){
        event.preventDefault();
        $(this).parent().find('ul.lang-submenu').slideToggle();
    });

/* 4. Home Slideshow
------------------------------------------------------------------------------*/

    $('.slideshow').slick({
        fade: true,
        cssEase: 'linear',
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        accessibility: false,
        draggable: false,
        infinite: true,
        pauseOnHover: false
    });

    $('.home-slideshow-in').on('init', function(event, slick, direction){
        $(this).addClass('main-animations');
    });

    $('.home-slideshow-in').slick({
        arrows: false,
        accessibility: false,
        fade: true,
        speed: 0,
        autoplay: true,
        autoplaySpeed: 6500,
        infinite: true,
        pauseOnFocus: false,
        pauseOnHover: false
    });

    $('.home-slideshow-in').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(this).removeClass('main-animations').addClass('next-animations');
    });

    

/* 5. Footer
------------------------------------------------------------------------------*/

    $('.offer__col .title').matchHeight();

/* 6. Subpage header
------------------------------------------------------------------------------*/

    $('.subpage-header .wrap').imagesLoaded( {
            background: true
        },
        function() {
            $('.subpage-header-in').addClass('animation-start');
            $('.subpage-header .slogan, .subpage-header .page-title').addClass('animated fadeInLeftSmall');
        }
    );

/* 7. Transitions between pages
------------------------------------------------------------------------------*/

    $(".animsition").animsition({
        inClass: 'fade-in',
        outClass: 'fade-out',
        inDuration: 300,
        outDuration: 300,
        linkElement: '.menu-item a:not(.caret), .site-logo, a.button:not([target="_blank"]), .lang-menu a',
        // e.g. linkElement: 'a:not([target="_blank"]):not([href^=#])'
        loading: true,
        loadingParentElement: 'body', //animsition wrapper element
        loadingClass: 'animsition-loading',
        loadingInner: '', // e.g '<img src="loading.svg" />'
        timeout: false,
        timeoutCountdown: 5000,
        onLoadEvent: true,
        browser: [ 'animation-duration', '-webkit-animation-duration'],
        // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
        // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
        overlay : false,
        overlayClass : 'animsition-overlay-slide',
        overlayParentElement : 'body'
      });

});